export default __webpack_public_path__ + "static/media/form-contact.f6836644.svg";